// import { Outlet } from 'react-router-dom'
// import LayoutsNavbar from '../../components/LayoutsNavbar/LayoutsNavbar'
// import Docsidebar from './Docsidebar'
// import Documention from './Documention'
// import Hero from './Hero'
// import Footer1 from '../../components/common/Footer1'
// import { useLayoutEffect } from 'react'
// const Doc = () => {
// 	useLayoutEffect(()=>{
// 		window.scrollTo(0,0)
// 	},[])
// 	return (
// 		<>
// 			<Docsidebar />
// 			<div className="main-content">
// 				<div className="position-relative">
// 				<LayoutsNavbar/>
// 				<div className='Outlet-m'>
// 					<Outlet />
// 				</div>

// 				</div>
// 				{/* <Hero />       <Documention/> */}
// 				{/* <Footer1 /> */}
// 			</div>
// 		</>
// 	)
// }

// export default Doc

import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Home, Menu, X } from 'lucide-react';
import DocSidebar from './Docsidebar';
import LayoutsNavbar from '../../components/LayoutsNavbar/LayoutsNavbar';
import ScrollToTop from '../../components/scroll-to-top/ScrollToTop';


export default function DocumentationPage() {
  const [activeSection, setActiveSection] = useState('Introduction');
  const [sidebarOpen, setSidebarOpen] = useState(false); // Default closed for mobile

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Simple Navbar */}
      <nav className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo and Title */}
            {/* <div className="flex items-center">
              <button
                onClick={() => setSidebarOpen(!sidebarOpen)}
                className="2xl:hidden p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[#50B5FF]"
              >
                <Menu size={24} />
              </button>
              <div className="flex-shrink-0 flex items-center ml-4 lg:ml-0">
                <Home className="h-8 w-8 text-[#50B5FF]" />
                <div className="ml-3">
                  <h1 className="text-lg font-semibold text-gray-900">ChatInject</h1>
                  <p className="text-sm text-gray-500">Documentation</p>
                </div>
              </div>
            </div> */}
            <LayoutsNavbar setSidebarOpen={setSidebarOpen} sidebarOpen={sidebarOpen} />

            {/* Desktop Toggle Button */}
            {/* <div className="hidden lg:block">
              <button
                onClick={() => setSidebarOpen(!sidebarOpen)}
                className="p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[#50B5FF]"
              >
                {sidebarOpen ? <X size={20} /> : <Menu size={20} />}
              </button>
            </div> */}
          </div>
        </div>
      </nav>

      {/* Sidebar Component */}
      <DocSidebar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        activeSection={activeSection}
        setActiveSection={setActiveSection}
      />
      {/* Main Content */}
      <div className={`transition-all duration-300 ease-in-out ${sidebarOpen ? 'lg:ml-80' : 'lg:ml-0'}  main-content`}>
        <div className="p-6 lg:p-8">
          {/* <div className="max-w-4xl mx-auto"> */}
          <div className=" ml-[0px] 2xl:ml-[310px] ">
            <div className="container 2xl:max-w-full 2xl:px-0">
              <ScrollToTop />
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
